import _extends from "@babel/runtime/helpers/extends";
import classNames from 'classnames';
import React from 'react';
import { classes } from './box-selection-item-wut.st.css';
import { BoxSelection as TPABoxSelection } from 'wix-ui-tpa/cssVars';
import { Checkbox } from 'wix-ui-tpa/cssVars';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const BoxSelectionItem = props => {
  const optionRef = /*#__PURE__*/React.createRef();
  const {
    content,
    className,
    hasError,
    inputId,
    ...optionProps
  } = props;
  const optionClassName = classNames(className, classes.option, classes.theme, {
    [classes.hover]: props.forcedHover,
    [classes.error]: hasError
  });
  useFocusFieldEvent(() => {
    var _optionRef$current;
    (_optionRef$current = optionRef.current) == null || _optionRef$current.focus({
      preventScroll: true
    });
  }, inputId);
  return /*#__PURE__*/React.createElement(TPABoxSelection.Option, _extends({}, optionProps, {
    ref: optionRef,
    className: optionClassName
  }), content);
};
BoxSelectionItem.includeCheckboxInBundle = Checkbox;
//# sourceMappingURL=box-selection-item.js.map